import React, { PropTypes } from 'react';
import BillLine from './BillLine';
import Big from 'big.js';
import BillDetailModal from './BillDetailModal';
import BillRichText from './BillRichText';
import ChooseModelModal from './ChooseModelModal';
import cx from 'classnames';
import $ from 'jquery';
import Immutable, { List } from 'immutable';
import shallowEqual from 'recompose/shallowEqual';

const sumTotalHt = lines =>
  lines.reduce((acc, curr) => acc.plus(curr.total_ht), new Big(0)).toFixed(2);

const emptyTvaAmount = () => {
  return {
    rate: 0,
    amount: new Big(0),
  };
};

const sumTotalTva = lines => {
  return lines.reduce((result, line) => {
    const tvaValueIndex = result.findIndex(
      elt => elt.rate.toString() === line.tva_rate.toString()
    );
    let tvaValue = emptyTvaAmount();
    if (tvaValueIndex === -1) {
      tvaValue.rate = line.tva_rate;
      tvaValue.amount = new Big(line.tva_amount);
      result.push(tvaValue);
    } else {
      tvaValue = result[tvaValueIndex];
      tvaValue.amount = tvaValue.amount.plus(line.tva_amount);
    }
    return result;
  }, []);
};

const generateTvaLines = lines => {
  const tvaLines = sumTotalTva(lines);

  return tvaLines.filter(line => line.rate !== 0).map(line => (
    <tr key={`tva_${line.rate}`}>
      <th colSpan="5" />
      <th>
        <strong>Total TVA - {line.rate}%</strong>
      </th>
      <th className="fullTotalTVA">{line.amount.toFixed(2)}</th>
    </tr>
  ));
};

const sumTotalTtc = lines =>
  lines.reduce((acc, curr) => acc.plus(curr.total_ttc), new Big(0)).toFixed(2);

const emptyLine = (isModel, defaultTVA) => {
  const emptyDefault = {
    label: '',
    description: '',
    quantity: '',
    unit_price_ht: '',
    tva_rate: defaultTVA,
    tva_amount: '',
    total_ht: '',
    total_ttc: '',
    accounting_code: '',
  };

  if (isModel) {
    return {
      ...emptyDefault,
      by_default: 'false',
    };
  } else {
    return emptyDefault;
  }
};

export class StatelessBillDetail extends React.Component {
  static propTypes = {
    lines: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    modelEnabled: PropTypes.bool,
    noTotal: PropTypes.bool,
    isModel: PropTypes.bool,
    beforeLinesName: PropTypes.string,
    afterLinesName: PropTypes.string,
    documentModelId: PropTypes.string,
    textBeforeLines: PropTypes.string,
    textAfterLines: PropTypes.string,
    deletedIds: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      modalOpened: false,
      chooseModelModalOpened: false,
      current: -1,
      tvaOptions: [],
    };

    this.onLineClick = this.onLineClick.bind(this);
    this.onNewLineClick = this.onNewLineClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onModalSave = this.onModalSave.bind(this);
    this.onDeleteLine = this.onDeleteLine.bind(this);
  }

  onLineClick(index) {
    return _ => {
      this.setState({
        current: index,
        modalOpened: true,
      });
    };
  }

  onNewLineClick() {
    this.setState({
      current: this.props.lines.length,
      modalOpened: true,
    });
  }

  onModalClose() {
    this.setState({
      current: -1,
      modalOpened: false,
    });
  }

  onModalSave(index) {
    return line => {
      const newLines = this.props.lines;
      newLines[index] = line;

      this.setState(
        {
          modalOpened: false,
        },
        () => {
          this.props.onChange({
            textBeforeLines: this.props.textBeforeLines,
            textAfterLines: this.props.textAfterLines,
            lines: newLines,
            deletedIds: this.props.deletedIds,
          });
        }
      );
    };
  }

  onDeleteLine(index) {
    return _ => {
      const toDelete = this.props.lines[index];
      const deletedIds = toDelete.id
        ? List(this.props.deletedIds)
            .push(toDelete.id)
            .toArray()
        : this.props.deletedIds;
      const newLines = List(this.props.lines)
        .delete(index)
        .toArray();

      this.props.onChange({
        textBeforeLines: this.props.textBeforeLines,
        textAfterLines: this.props.textAfterLines,
        lines: newLines,
        deletedIds: deletedIds,
      });
    };
  }

  onChooseModelModalClose = () =>
    this.setState({
      chooseModelModalOpened: false,
    });

  onModelSelected = model => {
    this.setState(
      {
        chooseModelModalOpened: false,
      },
      () => {
        this.props.onChange({
          textBeforeLines: model.text_before_lines,
          textAfterLines: model.text_after_lines,
          lines: this.props.lines,
          deletedIds: this.props.deletedIds,
        });
      }
    );
  };

  componentWillMount() {
    fetch('/pco-manager/settings/tva.json')
      .then(res => res.json())
      .then(res => {
        this.setState({
          tvaOptions: res,
        });
      });
  }

  onModelValueChange = field => value =>
    this.props.onChange({
      textAfterLines: this.props.textAfterLines,
      textBeforeLines: this.props.textBeforeLines,
      lines: this.props.lines,
      deletedIds: this.props.deletedIds,
      [field]: value,
    });

  shouldComponentUpdate(nextProps, nextState) {
    if (
      !shallowEqual(this.state, nextState) ||
      !shallowEqual(this.props, nextProps)
    ) {
      return true;
    }
    return false;
  }

  componentDidMount() {
    const { documentModelId } = this.props;
    // Handling choose model modal

    const chooseDocumentModelId = documentModelId
      ? documentModelId
      : '#ChooseDocumentModel';

    $(chooseDocumentModelId).on('click', () => {
      return this.setState({
        chooseModelModalOpened: true,
      });
    });
  }

  render() {
    const {
      current,
      modalOpened,
      chooseModelModalOpened,
      tvaOptions,
    } = this.state;
    const {
      readOnly,
      noTotal,
      isModel,
      beforeLinesName,
      afterLinesName,
      textBeforeLines,
      textAfterLines,
      lines,
    } = this.props;

    let currentLine = lines[current];
    let newLine = false;
    if (!currentLine) {
      const defaultTVA = () => {
        if (tvaOptions && tvaOptions.length > 0) {
          return tvaOptions[0].value;
        } else {
          return undefined;
        }
      };
      currentLine = emptyLine(isModel, defaultTVA());
      newLine = true;
    }

    const tvaOptionsWithCurrent = () => {
      if (tvaOptions.find(item => item.value === currentLine.tva_rate)) {
        return tvaOptions;
      } else {
        return Immutable.List(tvaOptions)
          .push({ value: currentLine.tva_rate, tvaOptions: tvaOptions.length })
          .toArray();
      }
    };

    const addButtonClass = cx('ui icon button create', {
      disabled: readOnly,
    });

    // const tvaLines = sumTotalTva(lines);

    return (
      <div>
        {!isModel && (
          <BillRichText
            label="Texte avant les lignes de prix"
            name={beforeLinesName || 'text_before_lines'}
            value={textBeforeLines}
            readOnly={readOnly}
            onChange={this.onModelValueChange('textBeforeLines')}
          />
        )}
        <table className="ui sortable table billLineList">
          <thead>
            <tr>
              <th className="one wide">
                <a className={addButtonClass} onClick={this.onNewLineClick}>
                  <i className="icon add" />
                </a>
              </th>
              <th>Libellé</th>
              <th>P.U HT</th>
              <th>Quantité</th>
              <th>Taux de TVA</th>
              <th>Montant TVA</th>
              <th>Montant TTC</th>
              {isModel && noTotal && <th>Insert. par défaut</th>}
            </tr>
          </thead>
          <tbody>
            {lines &&
              lines.map(l => (
                <BillLine
                  key={lines.indexOf(l)}
                  data={l}
                  readOnly={readOnly}
                  onClick={this.onLineClick(lines.indexOf(l))}
                  onDelete={this.onDeleteLine(lines.indexOf(l))}
                  isModel={isModel}
                />
              ))}
          </tbody>
          {!noTotal && (
            <tfoot>
              <tr>
                <th colSpan="5" />
                <th>
                  <strong>Total HT</strong>
                </th>
                <th className="fullTotalHT">{sumTotalHt(lines)}</th>
              </tr>
              {generateTvaLines(lines)}
              <tr>
                <th colSpan="5" />
                <th>
                  <strong>Total TTC</strong>
                </th>
                <th className="fullTotalTTC">{sumTotalTtc(lines)}</th>
              </tr>
            </tfoot>
          )}
          <BillDetailModal
            visible={modalOpened}
            readOnly={readOnly}
            index={current}
            line={currentLine}
            newLine={newLine}
            onClose={this.onModalClose}
            onSave={this.onModalSave(current)}
            isModel={isModel}
            tvaOptions={tvaOptionsWithCurrent()}
          />
        </table>
        {!isModel && (
          <BillRichText
            label="Texte après les lignes de prix"
            name={afterLinesName || 'text_after_lines'}
            value={textAfterLines}
            readOnly={readOnly}
            onChange={this.onModelValueChange('textAfterLines')}
          />
        )}
        {!readOnly && (
          <ChooseModelModal
            isOpened={chooseModelModalOpened}
            onConfirm={this.onModelSelected}
            onClose={this.onChooseModelModalClose}
          />
        )}
      </div>
    );
  }
}

export default StatelessBillDetail;



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/StatelessBillDetail.js